import { useEffect, useState, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL, FRONTEND_URL, CHATBOT_SCRIPT_URL } from "../../config";
import axios from "../../api/axiosInstance";

const ChatbotEmbed: React.FC<{ restaurantId?: string }> = ({ restaurantId }) => {
    if (!restaurantId)
    {
        restaurantId = localStorage.getItem("restaurant_id") || "";
    }
    const navigate = useNavigate();
    const [copied, setCopied] = useState(false);
    const [validRestaurant, setValidRestaurant] = useState(false);
    const iframeRef = useRef<HTMLIFrameElement | null>(null);

    const restaurantSlug = localStorage.getItem("restaurant_slug") || "";

    // const chatbotEmbedCode = `<script src="${CHATBOT_SCRIPT_URL}/chatbot.js?restaurant_id=${restaurantId}"></script>`;
    const chatbotEmbedCode = `<script defer src="${CHATBOT_SCRIPT_URL}/chatbot.js?slug=${restaurantSlug}"></script>`;

    const [planName, setPlanName] = useState<string | null>(null);




    useEffect(() => {
        const validateAndFetchPlan = async () => {
            if (!restaurantId) {
                console.warn("No restaurantId found, redirecting to login...");
                navigate("/login");
                return;
            }

            try {
                const validationRes = await axios.get<{ valid: boolean }>(`/chatbot/validate-restaurant/${restaurantId}`);
                if (!validationRes.data.valid) {
                    navigate("/login");
                    return;
                }
                setValidRestaurant(true);
                const planRes = await axios.get<{ plan_name: string | null }>(`/subscription/current-plan`);
                setPlanName(planRes.data.plan_name);
            } catch (err) {
                console.error("Validation or plan fetch failed:", err);
                navigate("/login");
            }
        };
        validateAndFetchPlan();
    }, [restaurantId, navigate]);

    const copyEmbedCode = useCallback(async () => {
        try {
            await navigator.clipboard.writeText(chatbotEmbedCode);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error("Copy error:", err);
        }
    }, [chatbotEmbedCode]);

    if (!validRestaurant) return <div className="p-6">🔒 Verifying access...</div>;

    return (
        <div
            className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-blue-500 to-purple-600 px-4 py-8">
            <div className="bg-white shadow-lg rounded-lg p-6 w-full max-w-2xl text-center">
                <h2 className="text-3xl font-extrabold text-gray-800 mb-3">💬 Embed AI Chatbot</h2>

                {planName ? (
                    <>
                        <p className="text-gray-600 text-lg">
                            Copy the code below and add it to your website:
                        </p>
                        <div
                            className="relative bg-gray-100 text-gray-800 text-sm font-mono p-4 rounded-lg mt-4 border border-gray-300">
                            <code className="break-words">{chatbotEmbedCode}</code>
                            <button
                                onClick={copyEmbedCode}
                                className="absolute top-2 right-2 bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded"
                            >
                                {copied ? "Copied!" : "Copy"}
                            </button>
                        </div>

                        <div className="mt-6">
                            <h3 className="text-lg font-semibold text-gray-700 mb-2">🔍 Live Preview</h3>
                            <div
                                className="mx-auto w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl border rounded overflow-hidden shadow-lg">
                                <div className="relative w-full" style={{paddingTop: "130%"}}>
                                    <iframe
                                        ref={iframeRef}
                                        // src={`${FRONTEND_URL}/chatbot-ui?restaurant_id=${restaurantId}&layout=compact`}
                                        src={`${FRONTEND_URL}/chatbot-ui/${restaurantSlug}?layout=compact`}
                                        title="Chatbot Preview"
                                        className="absolute top-0 left-0 w-full h-full rounded"
                                        style={{
                                            border: "none",
                                        }}
                                        sandbox="allow-scripts allow-same-origin"
                                    ></iframe>
                                </div>
                            </div>
                        </div>

                        <div className="text-left mt-8 bg-gray-50 p-4 rounded border border-gray-200">
                            <h3 className="text-lg font-semibold text-gray-700 mb-2">How to Use:</h3>
                            <ul className="list-disc pl-5 text-gray-600 space-y-1">
                                <li>Paste the script inside your website’s <code>&lt;body&gt;</code> tag.</li>
                                <li>Ensure your site allows JavaScript and cross-origin iframes.</li>
                                <li>The chatbot will appear at the bottom-right of the page.</li>
                            </ul>
                        </div>
                    </>
                ) : (
                    <div className="text-red-600 font-medium mt-6">
                        ⚠️ You currently have no active subscription. Please subscribe to access the embed code.
                    </div>
                )}
            </div>
        </div>
    );
};

export default ChatbotEmbed;
